// extracted by mini-css-extract-plugin
module.exports = {"viewPanorama":"ViewTour_viewPanorama__3noPE","menuBtn":"ViewTour_menuBtn__1Fn3V","scenesDropdown":"ViewTour_scenesDropdown__2mnRD","viewScenesBtn":"ViewTour_viewScenesBtn__1EmiL"};